import { BaseObject, IBaseObjectArgs } from "../../../core/business-objects/base-object/base-object.model";

export interface IAccountObjectArgs extends IBaseObjectArgs {
    account: string;
}

const defaults = {
    account: ""
} as IAccountObjectArgs;

export abstract class AccountObject extends BaseObject {
    account: string;

    constructor(data?: IAccountObjectArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-object/account-object.model.ts